export default __webpack_public_path__ + "static/media/question.077db540.gif";